export const common = {
  videoPlayProblemTipTitle:'Having Trouble Playing Videos?',
  walletBlanceTipTitle:'Mixin Messenger Privacy Wallet Tips',
  walletBlanceTipText1:'1. Please confirm your digital assets are in your Mixin Messenger privacy wallet.',
  walletBlanceTipText2:'Where to check your wallet: Close the bot and return to Messenger chat page, then on the Messenger bottom navigation bar: "Wallet" - "Privacy Wallet".', 
  walletBlanceTipText3:'If your assets are in other bots such as ExinOne or Pando trading accounts, you need to transfer them to your Mixin privacy wallet first. If on other blockchains or platforms, please withdraw and deposit to your Mixin privacy wallet.',
  walletBlanceTipText4:'2. Please confirm your wallet balance is sufficient. Also note that USDT has multiple versions, such as USDT(TRC20), USDT(ERC20), etc. Make sure it matches the ad requirements.',
  walletBlanceTipText5:'If versions don\'t match, we recommend filtering ads for the corresponding version, or using crypto-to-crypto exchange to convert to the appropriate USDT version before using TIGA.',
  showHowToSellArticle:'View How to sell coin tutorial',
  stillhaveQuestion:'Still have questions?',
  tradeDataTipsTitle:'Index Description',
  tradeDataTipsTitleSub:'Ad Publisher Data Index Description:',
  tradeDataTipsText1:'Total number of buy and sell orders completed within the last 30 days;',
  tradeDataTipsText2:'Completion rate within 15 minutes for non-optional mode orders in the last 30 days;',
  tradeDataTipsText3:'Completion rate of all orders in the last 30 days;',
  tradeDataTipsText4:'Positive rating rate of all orders in the last 30 days;',
  tradeDataTipsZhushi:'Note: If there are no orders within 30 days, old data ratios will be used. Data is dynamically calculated and may be delayed, for reference only.',
  plsAuthorizeMixin: 'Please Authorize Mixin account',
  mixinWsLoading: 'Waiting Mixin Authorization ...',
  cancelNeedClosePage: 'Please close this page directly~',
  escrowConfirmTitle: 'Notice',
  escrowConfirmText0:'The assets of transaction order will be escrowed to TIGA-safe, also the robot that initiated the trade group chat:',
  robotMixinID: '7000104225',
  robotName: 'TIGA-safe',
  mixinIDTitle: 'MixinID:',
  nameTitle:  'Name:',
  escrowConfirmText1: 'Clicking on「Pay Escrow」will open the Messenger payment page. Please confirm that the transfer information is correct and enter your PIN password to complete the escrow.',
  confirmPayEscrow: 'Pay Escrow',
  releaseConfirmTitle: 'Warning',
  releaseConfirmText0: 'Please make sure to confirm in your own account that the actual payment has been received and is consistent!',
  releaseConfirmText1: 'If you have received the transfer from the other party and agree to release the assets to their account, please enter the last 4 red digits and confirm.',
  releaseCodeError: 'Please enter the 4 red digits correctly',
  choosePass3: 'Maxium 3 item',
  coWarnTitle: 'Transaction Notice',
  coWarnText1: 'Please familiarize yourself with the platform rules and take relevant risk control measures before trading.',
  coWarnText2: 'Please strictly follow the robot prompts during trading.',
  coWarnText3: 'TIGA does not guarantee any user or behavior.',
  knownAgree: 'I promise to be aware of the above information, understand and agree',
  adjustFeeTitle: 'Fee Ajustment Notice',
  adjustFeeText: 'At present, there has been an adjustment to the platform handling fee. Please refer to 「Mine」-「Transaction Fee」for details. Please be informed.',
  cancel: 'Cancel',
  confirm: 'Confirm',
  loading: 'Loading...',
  noMore: 'No More',
  lang: 'Language',
  buy: 'Buy',
  buyer: 'Buyer',
  sell: 'Sell',
  seller: 'Seller',
  edit: 'Edit',
  remove: 'Remove',
  save: 'Save',
  submit: 'Submit',
  back: 'Back',
  pleaseInput: 'Please enter {input}',
  known: 'Yes, I know',
  reapply: 'Reapply',
  notice: 'Notice',
  copiedToClipboard: 'Copied to clipboard',
  follow: 'Follow TIGA-safe',
  yes: 'YES',
  no: 'No',
  stopRemind: "Don't remind next time.",
  reauthorize: 'Reauthorize',
  next: 'Next',
  start: 'Start',
  sendMessage: 'Send Message',
};

export const global = {
  settings: 'Settings',
  noticeListTitle: 'Notice List',
  noticeDetailTitle: 'Notice Detail',
  logoutInfo: 'Are you sure to exit?',
  mine: {
    activity: 'Activity',
    service: 'Service',
    about: 'About',
    green: 'Green Channel',
  },
  tigaRatesInfo: {
    title: 'Transaction Fee',
    landunTextTitle:'Blue Shield advertising rate', 
    commonTextTitle:'Ordinary advertising rate', 
    markerText: 'Advertising publisher (i.e. the party marker):',
    takerText: 'Advertising responder (i.e. the party taker):',
    markerTextOri: 'Advertising publisher:',
    takerTextOri: 'Advertising responder:',
  },
  login: {
    agreeInfo: 'Continuing to sign in means you have agreed',
    agreementName: 'User Agreement',
  },
  faqs:[
    {
      q:'What is TIGA',
      a:'TIGA is a decentralized C2C trading platform; TIGA is developed and operated by an independent asian team; TIGA is a robot developed on Mixin Messenger Based on Mixin Privacy network;<br/>Please note that TIGA trading assets must be assets on the Mixin chain, i.e. the assets in the Messenger Mixin privacy wallet.',
    },
    {
      q:'Differences from other platforms',
      a:'Decentralization of C2C transaction: TIGA does not have a centralized wallet and does not manage any assets of users.There is no need to mortgage assets to the platform for advertising. Anyone can buy and sell orders freely without threshold. <br/> Independent and strict platform risk control measures, it is recommended to read recent platform announcements before use.',
    },
    {
      q:'What is C2C peer-to-peer transaction',
      a:'Personal to personal direct buy and sell transactions, users determine the crypto asset for escrow, price, payment method, etc. by themselves. Platform provides crypto escrow service, information authentication, standard order process, etc. services to enhance transaction security. Note that the platform does not participate in pricing and trading, and does not make any guarantee.',
    },
    {
      q:'<span style="font-weight:bold;">How to use</span>',
      a:'1. Open the homepage of the TIGA robot, click the button in the upper right corner, and click [Buy] or [Sell]; <br/>2. Select the desired advertisement, click [Buy] or [Sell];  <br/>3. Enter the advertisement details page, enter the transaction amount and click [Take Order]; <br/>4. Enter the subscription details page, click [Group Chat] to enter the group chat.<br/>5. In the group chat operation, <span style="color:red;">please strictly follow the procedure prompted by the TIGA robot.</span><br/>6. It is recommended to familiarize yourself with small amounts for the first transaction.<br/>',
    },
    {
      q:'<span style="font-weight:bold; color:green;">How to ensure transaction security</span>',
      a:'The core of the platform is to provide services that enhance transaction security such as crypto asset escrow, information authentication, and standardized order process. ' +
   '<span style="font-weight:bold; color:red;">Please strictly follow the instructions on the bot page or messages. </span><br/>' +
   '<span style="font-weight:bold;">When buying crypto asset:</span><br/>' +
   'Please wait until the system confirms successful escrow and prompts you to make the transfer (or when the bot order details page shows escrow successful and the "I have paid" button appears), then carefully verify the order asset, amount, fiat amount, and the recipient\'s payment information before making the transfer.' +
   '<br/><span style="color:red;">After payment, click "I have paid" promptly. If you encounter any issues, contact TIGA human customer service immediately.</span>' +
   '<br/><span style="font-weight:bold;">When selling crypto asset:</span>' +
   'After the other party makes a payment, be sure to check your own payment account to confirm actual receipt and verify the information is correct before clicking "Release to the other party". ' +
   'Never rely on the other party\'s words or screenshots to determine whether payment has been received.' +
   '<br/><span style="color:red;">If you receive a payment that is not in other party real name, click "Funds not received", suggest returning it via the original payment method, and ask the other party to cancel the transaction.</span>',
    },
    {
      q:'<span style="color:red;">Special Notice</span>',
      a:'TIGA has the final jurisdiction over orders with objections from one or both parties and orders that have not been completed for more than 60 minutes;\nTIGA, also as the third party of trust decentralized transaction, does not make any guarantee for the possible loss of user assets and judicial issues in some regions;',
    },
    {
      q:'Advertiser Prohibited Actions',
      a:'TIGA does not allow private transactions outside the TIGA platform, especially inducing users to conduct private transactions. <br/>Once found, your account will be penalized depending on the degree of impact. <br/>Penalties include canceling the Blue Shield certification, temporarily or permanently restricting the publication of advertisements, and temporarily or permanently restricting your account, etc. <br/>Others please check <a href="http://help.tigaex.com/en/service-terms.html" target="_blank">Service Terms</a> ',
    },  
    {
      q:'<span style="font-weight:bold;">How to prevent fraud, bank card abnormalities, and frozen accounts</span>',
      a:'Do not conduct private transfer transactions, comply with local laws and regulations, follow platform rules, and carefully read platform announcements or articles regarding risk control and fraud prevention.',
    },   
    {
      q:'Can I trade without authentication',
      a:'Yes, but depending on the actual requirements of the counterparty. Moreover, general users will require authentication, which is not only a general regulation in the industry, but also can effectively reduce the transaction risk. TIGA recommends that you complete real name and advanced authentication in time to facilitate smooth transactions. ',
    },
    {
      q:'Is it mandatory to bind payment methods',
      a:'<span style="color:red;">No, it\'s not mandatory</span>. Binding payment methods only pre-stores the payment information in the TIGA system for convenient automatic sending to the other party in the trading group chat. It does not mean TIGA provides any guarantee or management of the payment account.<br/><span style="color:red;">In fact, you can also manually type and send it to the other party in the group chat.</span>',
    },
    {
      q:'<span style="color:#1b6fdc;">What is blue shield</span>',
      a:'Blue Shield users have more trading experience and risk awareness than ordinary users. During the event, the platform will give Blue Shield users more privileges and preferential fee rates.Please note that blue shield is only an objective authentication based on user data records, which does not mean that TIGA has any form of guarantee for it. <br/><span style="color:red;">The historical transaction records of Blue Shield users only represent the transaction records prior to the review time, indicating good trading habits and possibly higher credibility, but do not guarantee the safety of the current transaction.</span>Please carefully read TIGA platform\'s recent announcements regarding risk control and fraud prevention before trading.',
    },
    {
      q:'Video authentication',
      a:'Video authentication is a further enhancement of user authentication information. The content of knowing risks and committing asset compliance is to further ensure that users understand the risks of digital currency transactions, understand the compliance requirements of the platform, and assume corresponding responsibilities. It is recommended that users who choose video authentication for large transactions.',
    },
    {
      q:'How to cancel the order',
      a:'The order should be cancelled by both parties through negotiation. If the other party does not want to cancel the order online for 15 minutes, it will automatically cancel the order;\nIn case of any disagreement during the transaction, both parties shall cancel it through negotiation; If one party does not respond or refuses to cancel, after 60 minutes of order timeout,please contact TIGA customer service to appeal for cancellation.',
    },
    {
      q:'Order appeal',
      a:'Please confirm that you have contacted the other party through mixin messenger and telephone before submitting your complaint. if the transaction cannot be cancelled through negotiation,after 60 minutes of order timeout, please contact the customer service and leave a message about the order number, screenshot of transaction group chat, transfer voucher and other help for arbitration. For malicious appeal users, TIGA will blackmail them.  TIGA will also blackmail users who do not cooperate with complaints or do not respond after exceeding the number of times.',
    },
    {
      q:'I can\'t see my own advertisement',
      a:'Please check whether the time zone and time period settings are correct and confirm that there are no orders with unpaid handling charges.',
    },
    {
      q:'Why is account restricted & How to restore it',
      a:'Tiga system will automatically pull black or manually pull black after determining whether it is a high-risk user according to the user\'s wallet flow and transaction behavior. Please comply with local laws and regulations. Please contact TIGA staff for cancellation Or waiting for the system to automatically release.',
    },
  ],
  faqsMore:'<span style="color:#1b6fdc;">More</span>',
};

export const exchange = {
  name: 'Exchange',
  noFindTitle: "Couldn't find the ad you want",
  noFindSuggest:
    'Unfortunately, the ad you searched is not found. You can post your own ads and wait for others to respond.',
  allAds: 'All ads',
  postAnAds: 'Post an Ad',
  filterMethod: 'Buy/Sell',
  methodFilterOptions: ['Buy/Sell', 'Buy', 'Sell'],
  filterCrypto: 'Crypto',
  filterPayment: 'Payment',
  filterLocation: 'Location',
  filterLegalCurrency: 'Legal Currency',
  allLegalCurrency: 'All Currency',
  pickMethodTitle: 'Buy/Sell',
  pickTitle: 'Choose a {picker}',
  noLimit: 'No Limit',
  anyPayment: 'Any Payment',
  anyWhere: 'Anywhere',
  tradeCount: '{count} trades',
  praise: 'praise',
  successRate: 'success',
  fast: 'fast',
  optionalMode: 'Optional Mode',
  tradeWith: 'Trade With these Buyers/Sellers',
  kyc: 'KYC',
  blueTrust: 'Blue Shield Trust',
  kycVideo: 'video authentication',
  goKyc: 'Go',
  buy: 'Buy',
  sell: 'Sell',
  info:
    'TIGA is a worldwide peer-to-peer marketplace where buy and sell cryptocurrencies. If you want to know how to trade, please refer to',
  notFound: 'Not Found',
  filterPlaceholder: 'Please enter filter criteria',
  sortCondition: {
    created_at: 'Release time',
    updated_at: 'Modification Time',
    price_asc: 'Prices from low to high',
    price_desc: 'Price from high to low',
    abs_price: 'Close to market price',
    order_count: 'Orders amount',
    turnover: 'Total transaction volume',
    evaluation: 'Good reviews amount',
    recommend: 'Recommend',
  },
};
export const post = {
  name: 'Post',
  postAds: 'Post an Ad',
  postAnAd: 'Post an Ad',
  postDes:
    'Please note that advertising on this page only supports Mixin chain assets. Before advertising, please familiarize yourself with the platform rules and take corresponding risk control measures. TIGA does not provide any guarantees.',
  myAds: 'My Ads',
  buy: 'Buy',
  sell: 'Sell',
  delistAll: 'Take down all ads',
  listAll: 'Recovery',
  delistAllAlert: 'Confirm to take down all for sale/buy ads?',
  listAllAlert: 'Restore only the ads that were last taken down.',
};
export const createPost = {
  name: 'Post An Ad',
  adType: 'Ad Type',
  optionalMode: 'Optional Mode',
  unchecked: 'Unchecked',
  checked: 'Checked',
  optionalModeBrief: 'need more infomation to complete order.',
  onlyForSell: 'Only For 「Post a sell ad」.',
  attribute: 'Ad Property',
  public: 'Public',
  private: 'Only Mixin Group',
  buy: 'Post a buy(crypto) ad',
  sell: 'Post a sell(crypto) ad',
  crypto: 'Crypto',
  payment: 'Payment',
  fiatCurrency: 'Fiat Currency',
  customizePrice: 'Customize Price',
  tradeAmount: 'Trade Amount',
  location: 'Location',
  standardHours: 'Standard Hours',
  headline: 'Headline',
  termsOfTrade: 'Terms Of Trade',
  trader: 'Trading partners',
  defaultTrader: 'Default all users',
  selectedTrader: 'Conditional users',
  postAd: 'Post',
  default: 'Please',
  createSuccess: 'Create Successfully',
  saveSuccess: 'Save Successfully',
  removeSuccess: 'Remove It Successfully',
  TakeOffSuccess: 'Delist Successfully',
  putOnSuccess: 'List Successfully',
  quit: 'Quit',
  quitContent: 'Are you sure you want to quit {action} ad?',
  removeContent: 'Are you sure you want to remove this ad?',
  quitPosting: 'posting',
  quitEditing: 'editing',
  setPriceAlert: 'Please choose A Crypto and A Fiat Currency Firstly.',
  setAmountAlert: 'Please choose A Fiat Currency Firstly.',
  setPriceFirstAlert: 'Please set The Price Firstly.',
  takeOff: 'Delist',
  putOn: 'List',
  editInfo: 'If you need to edit or remove ad, please delist it first.',
  detail: 'Ad Detail',
  safeAlert:
    'Sorry, the default checkboxes do not support cancellation for more secure transactions.',
};
// Page Customize-XXX
export const customize = {
  fixedPrice: 'Fixed Price',
  dynamicPrice: 'Dynamic Market Price',
  referencePrice: 'Reference Price(not indicative of actual value): ',
  referenceText:
    "Your current price (as a seller): 1 {symbol} = {sellPrice} {unit}. Buyer's current price: 1 {symbol} =  {buyPrice} {unit} including TIGA fee",
  dynamicPriceText: [
    'What margin and exchange do you want to use for your rate',
    'Choose a percentage margin',
  ],
  dynamicReference: 'Choose A Reference',
  dynamicAboveOrBelow: 'Above/Below',
  above: 'Above',
  below: 'Below',
  percentage: 'Percentage',
  isDeveloping: 'In the developing, so stay tuned.',
  minTradeAmount: 'Minimum Trade Amount',
  maxTradeAmount: 'Maximum Trade Amount',
  standardHoursTitle: 'Do you want to set your standard hours',
  standardHoursSubtitle:
    "These are the hours that you are normally available for contact. Your offer will be shown to more users if you respond to messages quickly, however you won't be penalized for any delays outside of your standard hours.",
  timeZone: 'Select your local timezone',
  timeStart: 'Wake',
  timeEnd: 'Sleep',
  difference: 'Price gap',
  exinone: 'ExinOne fiat',
  traderBrief:
    'The setup will increase the security of trading while reducing trading opportunities.',
  lowestPrice: 'Lowest price',
  dynamicPriceNotice: 'Please note that this price setting may deviate from the fair market price due to interface updates or other reasons. Please be sure to check and confirm the price before actual trading.',
};
export const mine = {
  name: 'Mine',
  loginIn: 'Login In',
  createdAt: 'Registered At: {date}',
  orders: 'Orders',
  userAgreement: 'User Agreement',
  privacyPolicy: 'Privacy Policy',
  faq: 'FAQ',
  customerService: 'Customer Service',
  about: 'About',
  exitSuccess: 'Exit Successfully!',
  what_is_kyc: 'Passed KYC First',
  what_is_blue_trust: 'Passed Blue Shield Trust in TIGA',
  firstLoginFailedTip: 'First login failed, please login again (trigger other authorization methods)',
};
export const newSettings = {
  todamoonTitle: 'Instructions',
  todamoonDetails: [
    {
      title:
        'Decentralized',
      content:
        'TIGA is based on Mixin multi sign function. In the whole transaction process, crypto assets are on multi sign addresses without trust and truly decentralized;',
    },
    {
      title: 'Perfect reproduction',
      content:
        'functions such as KYC, KYC advanced, Blue Shield advanced, community, invitation and commission, orders statitics,list management are complete. ',
    },
    {
      title:
        '<span class="strong"> Blue Shield user green authentication</span>',
      content: 'Blue Shield users of other platforms like huobi,binance,exinlocal,etc. can directly apply for Blue Shield after basic KYC, <span class="strong">Please apply in time when the activity is limited</span>',
    },
    {
      title: '<span class="strong">Come to TIGA, one more choice</span>',
      content: 'Come on，join us~',
    },
  ],
  applyGreen:{
    title: 'Blue Shield Certification',
    warningInfoTitle:'Note：',
    warningInfo:' 1. Under the age of 45, familiar with and understanding of platform rules and features, able to independently resolve any process issues other than order disputes. Be able to communicate actively and friendly with trading partners or platforms, and cooperate to solve various problems. \n 2.Register TIGA for 360 days and pass advanced certification and video certification. \n 3. There must be a record of completed orders for buying and selling, with at least 10 purchases of cypto, a single amount of 10000 CNY or more, and payment funds deposited in the other party\'s account for at least 15 days without any abnormal feedback records. \n 4. No private transactions or induced private transaction records. \n 5. If you have already met the above conditions, please leave a message to customer service. The actual approval or rejection is subject to further review. \n Special note: The actual certification rules may be dynamically adjusted according to risk control measures. If not approved, please wait at least 30 days before initiating the application. Blue Shield authentication or not does not affect advertising and transaction functions. ',
    waitInfo:'Please add the reviewer as a friend, and explain the requirement: Blue Shield certification, thank you.',
    contactServiceMan:'Contact review',
  },
  kyc:{
    title: 'KYC ',
    resultTitle: 'KYC authentication status',
    trueNameErr: 'Truename invalid',
    idcardNumberErr: 'Idcard Number invalid',
    idcardFrontErr: 'Photo idcard front invalid',
    idcardBackErr: 'Photo idcard back invalid',
    idcardWithErr: 'Photo holding card&paper invalid',
    uploadTips:'Tips: Please keep the photos consistent with the text data, and keep the clarity when taking photos with your ID card and paper with the word "TIGA"(Handwriting is sufficient).',
  },
  kycAdv:{
    title: 'KYC Advanced',
    photosInfo: 'Photos', 
    photosLimit: 'Maximum upload 6 photos',
    photosEmptyErr: 'Photo is empty',
    uploadTips:'Tips: Please provide one or more address proof photos (except for ID) SIMULTANEOUSLY containing your real name & ID Number & address information, such as driver license,water and electricity payment records, house purchase contract, deed tax, house property certificate, etc. Suggest uploading 2 or more photos for faster approval.Depending on the risk control, different users may have different data requirements, please pay attention to the audit results.',  
  },
  kycVideo:{
    tempForChineseOnly: 'Temporarily only accept users in mainland China',
    notKeepInfo:'声明：您的视频信息TIGA将严格保密。',
    title: '视频认证',
    katoonTitle: '视频认证拍摄动画说明',
    nickname: '昵称',
    videoInfo: '视频', 
    videoLimit: '建议视频大小勿超过10M',
    videoEmptyErr: '视频不能为空',
    uploadTips:'本人姓名***， 身份证号****，已知晓TIGA平台规则，已知晓TIGA不作任何担保，已知晓交易数字币风险，本人所有资产或款项均合法所得，所有交易行为均为本人自愿且亲自处理，风险全部由本人承担。(TIGA按英文字母tiga依次读，也可读“迪迦”或“泰格”)',
    uploadTips1:'请手持身份证和TIGA纸张(任意白纸上手写TIGA即可)，口述上述蓝色字体内容（不包含括号内，不要增加或减少字句）, 期间拍摄证件正反面。',
    uploadSkill: '建议上传视频前将视频压缩，例如通过微信等聊天软件再保存后可有效压缩。如还有问题请直接联系客服解决。 TIGA也可以读作“迪迦”“提呷”“泰格”等类似读音，但一般必须与TIGA纸张同时出镜，审核以表意明确为准。', 
    iphoneUploadTips: '部份手机系统例如iphone IOS,如上传压缩后的视频时还是提醒文件过大（ios系统机制自动转换了）。请在上传时不要选择「照片图库」，而是选择「选取文件」(位置「浏览」-「我的iphone」)。进入本页面之前需将压缩后的mp4视频进行如下操作：手机照片中选择压缩后的视频「共享」-「导出未修改的原片」-「存储」（存储位置：「浏览」-「我的iphone」）',
    uploadTipsSpecial: '特别注意：请勿遮挡面部，保持画面和语音清晰。期间翻转拍摄证件正反面时，靠近镜头，确保证件聚焦清晰，注意人和证件一直同时在镜头内。',
    scrollForTips: '向下滑动查看更多拍摄提示',
  },
  apply:{
    wait: 'Waiting',
    waitInfo:'Your information is under review. Generally, the review is completed within one working day. Please wait patiently, thank you',
    adopted:'Success',
    adoptedInfo:'Congratulations! Your KYC certification has been passed.',
    fail:'Failed',
    failInfo:'Tips：',
    forbidden: 'Forbidden',
    forbiddenInfo:'Tips：',
  },
  notKeepInfo:'Statement: Your photo information will be used for TIGA platform review only.',
  personalInfo: 'Personal Info',
  trueName: 'Full Name', 
  nickname: 'Nickname',
  idcardNumber: 'ID Card Number', 
  idcardFront: 'ID Card (front)', 
  idcardBack: 'ID Card (back)', 
  idcardWith: 'ID Card & Paper written \'TIGA\' (hold)', 
  upload: 'upload', 
  reUpload: 're-upload', 
  uploadInfo:
  'Tips: your information will be kept strictly confidential and only used for TIGA KYC authentication. Please fill in the content truthfully to maintain a good trading environment',
  tips:{
    trueNamePlaceholder:'Please input your true name',
    idNumberPlaceholder:'Please input your ID number',
  },
  incorrect: 'Please input corret {name}',
};
// page apply
export const apply = {
  notice: 'Application is limited to users who have a need to list an ad.',
  name: 'Apply for Blue Shield Trust',
  personalInfo: 'Basic information',
  trueName: 'fullname',
  phoneNumber: 'phone number',
  email: 'your Email',
  wait: 'Waiting for review',
  waitInfo:
    'Your application has been submitted and you will be contacted by a staff member during the review process, so please keep your phone and Mixin open.',
  success: 'Application approved',
  emergencyContact: 'your emergency contact',
  emergencyContactNumber: 'your emergency contact number',
  emergencyContactRelationship: 'your emergency contact relationship',
  kycFirst: 'Please go to "Mine, Settings" to complete KYC before applying for Blue Shield.',
  goKyc: 'Go KYC',
  clickPlaceholder: 'click here',
  info: {
    title: 'About Blue Shield Trust audit standards',
    list: [
      '1. Registered to TIGA for 90 days or more (this condition may be relaxed for team accounts of Blue Shield trust).',
      "2. When submitting a Blue Shield Trust application, there must be no record of TIGA platform users' feedback that the other party's payment account was abnormal due to their payment reasons, etc., within the last six months.",
      '3. Failure of the account and its manager to report any past history of being detained by the police, named for investigation and evidence gathering, or frozen by the police, as a result of investigative or restrictive measures taken by the relevant public authority.',
      '4. There have been no serious breaches or repeated breaches of the terms of the TIGA platform for pending transactions on the account.',
      "5. Assessment of the account's overall service level and risk control level through the service and risk control departments.",
      '6. In the audit process, certifying parties are required to complete KYC and advanced authentication according to staff guidelines.',
      '7. Other standards may be relaxed if the cumulative number of successful OTC pending order transactions in other OTC platforms exceeds 100 or more; (relevant information must be submitted to substantiate the application).',
      '8. If the above conditions are met, they will be reviewed and added in batches according to the date of registration.',
    ],
  },
  info1: {
    title: 'Advantages of applying for Blue Shield Trust',
    list: [
      '1. the fee during the event is 0.1%, non-Blue Shield trust fixed 0.25%.',
      '2. Listing orders support the selection of trading objects, trading security is higher.',
    ],
  },
  QAs: [
    {
      question: 'How do you plan to use TIGA for your transactions?',
      options: [
        'Mainly trade as taker',
        'Mainly trade as maker',
        'Both taker and maker',
      ],
    },
    {
      question: 'Have you ever used other crytocurrency trading platforms?',
      options: [
        'No, I have only used C2C trading of TIGA',
        'I have used other C2C trading platforms within the Mixin ecosystem, such as ExinLocal, ZOTC',
        'I have used other C2C exchanges outside of Mixin such as Huobi, BigONE, OKEx, etc.',
      ],
    },
    {
      question:
        'Have you ever used other crytocurrency trading platforms to trade crytocurrency in C2C?',
      options: [
        'Only bought, not sold',
        'Only sold, didn\'t buy',
        'Bought and sold both',
        'I have used them for a long time, but not in the last year',
      ],
    },
    {
      question: 'What is your main need for trade as taker?',
      options: [
        'Low price to buy USDT to make fixed investment',
        'Arbitrage to make money',
        'Other',
      ],
    },
  ],
  tips: {
    tips: 'Tips',
    tipsLsit: [
      'No need to apply for the Blue Shield to trade as taker.',
      'Temporarily do not meet the application requirements.',
      'Applications have been submitted and will be reviewed within 2 business days. Contact Alim to check progress.',
      'Hello, please complete KYC verification.',
      'Hello, please complete the advanced certification.',
      'Hello, your registration is less than 90 days and you are not eligible to apply.',
      // 'Hello, please register your {exinOne} account and complete your KYC verification first.',
      'Hello, non-Blue Shield users can also use TIGA to trade, just place an order directly without applying for Blue Shield certification.',
      'You need to complete the following operations to continue to apply for Blue Shield certification:',
      'Please simply fill in your needs',
    ],
  },
  noMatch: 'Not matched',
  search: 'Search',
};

// Page Orders
export const orders = {
  name: 'Orders',
  noRecords: 'No Records',
  buy: 'Buy {symbol}',
  sell: 'Sell {symbol}',
  amount: 'Amount',
  price: 'Price',
  total: 'Total',
  all: 'All',
  done: 'Completed',
  pending: 'Uncompleted',
  cancel: 'Canceled',
  startingTime: 'Starting time',
  endTime: 'End Time',
  startingTimeTips: 'Choose start time',
  endTimeTips: 'Choose end time',
};

export const payInfo = {
  name: 'Settings',
  settings: [
    {
      title: 'Preference Of Currency',
      placeholder: "default for exchange's page",
    },
    {
      title: 'P2P Payment Methods',
      content: 'Associated',
      placeholder: 'Click here to add payments',
    },
    {
      title: 'SMS Auth',
      placeholder: 'Click here to associate with SMS',
    },
    {
      title: 'Invite Code',
      placeholder: 'Click here to bind',
    },
    {
      title: 'KYC',
      placeholder: 'Click here to go KYC',
    },
    {
      title: 'Advanced KYC',
      placeholder: 'Click here to go KYC-adv',
    },
    {
      title: 'Video Authentication',
      placeholder: 'Click here',
      content: 'Click here',
    },
  ],
  goKycAlert: 'Go KYC first.',
  goKyc: 'Go KYC',
  passed: 'Passed',
  settingInfo:
    'Adding a payment method is designed to make transactions easier and TIGA takes the privacy of its users very seriously, and adding a payment method is not mandatory.',
  noKycAlert: 'Please finish KYC first.',
  noKycAdvAlert: 'Please finish Advanced KYC first.',
  syncAlert:
    'The current data will be overwritten during synchronization. Do you want to confirm the synchronization?',
  cancelSync: 'Cancel',
  confirmSync: 'Confirm',
  syncing: 'Synchronizing...',
  synced: 'Synchronize Successfully',
  add: 'Add',
  addPayment: 'Add Payment',
  trueName: 'Name',
  nickname: 'User Nickname',
  edit: 'Edit',
  bankAccount: 'Bank account',
  bankName: 'Bank name',
  openingBank: 'Account opening branch(optional)',
  alipayAccount: 'Alipay account',
  wechatAccount: 'Wechat account',
  removeSuccess: 'Remove It Successfully',
  personalInfo: 'Personal Info',
  qr: 'Receive QR Code(optional)',
  upload: 'Upload',
  uploadInfo:
    'Tips: When you sell or buy cryptocurrency, the payment method you choose will be shown to the other party, please make sure the information is filled out correctly.',
  deleteAlert: 'Are you sure to remove it?',
  recommand: 'Recommand Payments',
  next: 'Go Next',
  incorrect: 'Incorrect {name}',
  authorizeAlert:
    'Hello, you need to authorize phone number permissions to bind it, please do not uncheck the box.',
  select: 'Pick a payment',
  send: 'Send',
  sendSuccess:
    'Send successfully, please click the "X" in the upper right corner to close the current page.',
  default: 'Default',
  setDefault: 'Do you want to set {payMethod} as the default?',
  cancelDefault: 'Do you want to cancel the default?',
  switchOpened: 'This payment is opened',
  switchClosed: 'This payment is closed',
  bindRuleErrorInfo: 'Sorry, accounts with existing transactions no longer support binding.',
};

export const takeOrder = {
  amountErrorTip: 'Your current wallet {symbol} balance is 0 or cannot be obtained. Please confirm your wallet assets or upgrade to the latest version of Messenger before trying again!',
  notPrimaryWebAmountTip: 'You are currently not using the TIGA robot main web page and cannot obtain the Mixin Privacy wallet asset balance. Please confirm that the asset balance is sufficient and initiate the transaction directly. (USDT, please distinguish between advertising versions)',
  amountZeroTip: 'Please confirm the asset status in Mixin Privacy Wallet.',
  titleSell: "You Are Buyer. Transfer To Seller's Account With {name}",
  titleBuy: 'You Are Seller. Receive With {name}',
  titleMultiSell:
    "You're the buyer and transfer to the seller's account by agreement",
  titleMultiBuy: "You're the seller, receive money by agreement.",
  priceInfo:
    '{name} Set This Price <br/>The Trade Continues Only With Your Consent',
  tradeLimit: 'Trade Limit',
  takeOrder: 'Take Order',
  safetyInfo:
    'Once you take the order, the transaction will ontinue to be completed in the Mixin Messenger encrypted group chat. Please respond in time after the transaction group chat starts to avoid possible losses to yourself or the other party.',
  priceNotInRange: 'Out of range',
  lastSeen: 'Last seen {duration}',
  successMsg:
    "Please continue trading in the Mixin Messenger group chat. Click 'Confirm' join.",
  noSupported:
    "Your Mixin Maybe not support the Mixin Network's multi-signature, Please update to the lastest version.",
  notEnoughAmount: 'The balance of this asset in your current Mixin privacy wallet is insufficient. Please check if the asset version is consistent.',
  limitedTimeActivity:
    'Limited-time event: trades with Blue Shield Trust users are commission-free for a limited time and faster.',
  share: 'Share',
  contact: 'Contact',
  shareMsg:
    'Click the 3 dots in the upper right corner to share with others to place a order quickly.',
  sellTo: 'Sell {coin} to {name}',
  buyFrom: 'Buy {coin} from {name}',
  balance: 'Balance in Mixin Privacy Wallet: ',
  needBalance: 'To successfully complete the transaction, please ensure that the Mixin privacy wallet balance is higher than:',
  lessThanMin: 'Less than the minimum',
  moreThanMax: 'More than the maximum',
  forbiddenRemark:
    'When transferring money or adding friends, <b class="important">please do not note any information,</b> otherwise your account may be frozen by the platform, and the other party may not refund or release the coins.',
  optionalModeDetail:
    'Optional mode ads are more secure compared to regular ads. After you place an order, the other party needs more information(such as the flow of payment method) from you to decide whether to proceed with the transaction. You can cancel after the other party has escowed the order and it will not count towards the number of cancellations for the day.',
};

export const payments = {
  BinanceTransfer: 'Binance',
  OKXTransfer: 'OKX',
  BigONETransfer: 'BigONE',
  GateioTransfer: 'Gateio',
  CryptoTransfer: 'Crypto Address',
  alipay: 'Alipay',
  wechatpay: 'Wechat Pay',
  unionpay: 'Union Pay',
  YandexMoney: 'Yandex.Money',
  'Western Union': 'Western Union',
  PayPal: 'PayPal',
  'Mercado Pago': 'Mercado Pago',
  Paytm: 'Paytm',
  'International wire': 'International wire',
  'Gift card': 'Gift card',
  'Cardless cash': 'Cardless cash',
  Efecty: 'Efecty',
  QIWI: 'QIWI',
  Pingit: 'Pingit',
  'Bank transfer': 'Bank transfer',
  Venmo: 'Venmo',
  Swish: 'Swish',
  'SEPA transfer': 'SEPA transfer',
  MoneyGram: 'MoneyGram',
  Other: 'Other',
  'Cash deposit': 'Cash deposit',
  AdvCash: 'AdvCash',
  WebMoney: 'WebMoney',
  UPI: 'UPI',
  'WeChat Pay': 'WeChat Pay',
  TransferWise: 'TransferWise',
  'Interac e-Transfer': 'Interac e-Transfer',
  IMPS: 'IMPS',
  'M-PESA': 'M-PESA',
  Skrill: 'Skrill',
  'Cash (in person)': 'Cash (in person)',
  Alipay: 'Alipay',
  PayNow: 'PayNow',
  PAYEER: 'PAYEER',
  'Alfa cash-in': 'Alfa cash-in',
  Velo: 'Velo',
  'Google Pay': 'Google Pay',
  default: '-',
};

export const result = {
  cancelContent:
    'Hello, please be careful to cancel transactions, more than 2 cancellations on the same day can not continue to place orders, and may be limited by the system, please regulate the use.',
  notReceivedContent: 'Are you sure you do not receive the transfer?',
  cancelTransaction: 'Cancel Order',
  transferAlert:
    'Hello, have you confirmed that you have made payment to the other party? If you have not paid, you may be restricted from TIGA for multiple malicious clicks.',
  close: 'Close Tip',
};

export const error = {
  occur: 'Error Occurred: ',
  occurs: 'Error Occurred',
  para: 'Bad Parameter',
  unknown: 'Unknown Error',
  jwtInvalid: 'Login Credentials Invalid. Please Login Again',
  jwtUpdated: 'Login Credentials Updated. Please Try Again',
  jwtExpired: 'Login Credentials Expired. Please Login Again',
  jwtUpdating: 'Updating Login Credentials',
  reqTimeout: 'Request Timeout. Please Try Again',
  networkError: 'Network Error. Please check your connection',
  forbidden: 'Forbidden',
  tooManyReq: 'Too Many Requests',
  serverError: 'Server Error. Please Try Again',
  notTradeWithSelf: 'Advertising publisher cannot trade',
  notSend: 'The escrow has not been paid',
  notSign: 'No data to sign',
  notUnsign: 'No data that can be unsigned',
  notWithdraw: 'No assets to withdraw',
  insufficientBalance: 'Insufficient asset balance',
  incorretPrice: 'Fiat price calculation is incorrect',
  withoutLimit: 'The trade price must be between the limits',
  tokenMiss: 'Token Miss',
  tradeOver: 'The trade has ended',
  inSigning: 'The trade is already in the signing phase',
  notRepeat: 'Do not repeat',
  notEscrowed: 'The trade is not yet escrowed',
  notRelease:
    'Signatures have not been collected, and assets cannot be released',
  permissionDenied: 'You do not have permission to operate',
  needCancelSignature:
    'The trade is already in the signing phase, please cancel the signature first',
  needCancelEscrow:
    'The trade is already escrowed, please cancel escrow it first',
  notCancel: 'This trade has ended and cannot be cancelled',
  abnormalStatus: 'Abnormal trade status',
  isCanceled: 'The trade has been cancelled',
  delistBeforeEdit: 'Ad is listing and is not available for editing',
  delistBeforeDelete: 'Ad is listing and is not available for deleting',
  isDelisted: 'This ad is delisted and no longer available for trading',
  sellerIsNotEnough: 'The crypto amount of other side is not enough to trade',
  buyerIsNotEnough: 'Your crypto amount is not enough to trade',
  refundFailed: 'Service fee refund failed',
  loginDenied: 'Login Denied',
  notCheckCounterpartyAssets:
    "Unable to check the adequacy of the counterparty's assets",
  uncompeletedTrade: 'Please complete the last trade first',
  outOfRateRange:
    'In order to maintain a healthy market environment, the percentage of dynamic price is recommended to be set above or below 5%.',
  invalidEmail: 'Please enter the correct format of the email.',
  unsupportedCrypto:
    'Sorry, this crypto is temporarily unsupported in the ExinOne fiat area.',
  unsupportedExinOne:
    'Sorry, only RMB price is available in ExinOne fiat area.',
  onlyKyc:
    'Seller settings only support KYC authenticated users to place orders, please go to KYC first.',
  onlyOldUser:
    'Sorry, the other side setting only supports transactions by users who have registered for 90 days or more.',
  onlyHasTrade:
    'Sorry, the other side setting only supports transactions by users who trade 5 or more times.',
  onlyHighQuality:
    'Sorry, the other side setting only supports Premium User transactions.',
  notSatisfiable:
    'Sorry, you do not meet the requirements of the person you are dealing with.',
  outOfAdLimit: 'No more than three ads of the same type. ',
  advVerify:
    'Sorry, you triggered advanced verification and are unable to continue operation, please complete advanced verification.',
  joinChatFailed:
    'Sorry, create group failed, please add TIGA bot as contact.',
  onlyWhiteList:
    'Hello, the other party has set only whitelist can trade, please select other users.',
  reauthorize:
    "The operation need your Mixin's authorization, please reauthorize.",
  optionalMode:
    'In order to ensure that you do not provide services for various illegal acts, please turn on the "Optional Mode" and strictly examine the other party\'s fund details and flow to ensure the safety of the trade.',
};

export const orderDetail = {
  name: 'Order details',
  orderNumber: 'Order number',
  buyer: 'Buyer',
  seller: 'Seller',
  cryptoWallet: 'Crypto wallet',
  paymentMethods: 'Payment methods',
  amount: 'Amount',
  price: 'Price',
  total: 'Total',
  yourRating: 'Your rating',
  opponentRating: 'Opponent rating',
  orderProgress: 'Order progress',
  assistance: 'For help, please leave message on the TIGA bot.',
  escrow: 'escrow',
  paid: 'paid',
  draw: 'draw',
  done: 'done',
  cancel: 'cancel',
  joinChat: 'Join group chat',
  sellerPhone: "Seller's Phone",
  buyerPhone: "Buyer's Phone",
};

export const evaluation = {
  name: 'Rating',
  hello: 'Hello, you have completed the trade, please rate the other party',
  good: 'Good rating',
  bad: 'Bad rating',
  mid: 'Mid rating',
  assistance: 'For help, please leave message on the TIGA bot.',
  reason: 'Hello, you have selected a bad review, please check the reason',
  timely: 'Lack of timely response',
  slow: 'Slow payment',
  process: 'Unskilled process',
  other: 'Other',
  limit: 'Hi, TIGA 20 character limit',
  submit: 'Submit',
  haveEvaluated: 'You have evaluated',
  evaluateSuccess: 'Evaluate Successfully',
  tips: 'Please select a reason for a bad rating',
  otherReason: 'Please enter a reason',
};

export const logStatus = {
  create_group: 'Trade Creating',
  start: 'Escrowing',
  escrow: 'Escrowed',
  escrow_need_check: 'Escrowed But Need Confirm',
  deal_continue: 'Confirm & Continue Trade',
  many_payments: 'Waiting Choose Payment Method',
  paid: 'Paid',
  transfer_asset: 'Pending release',
  pay_confirm: 'Payment confirmed',
  sign_asset: 'Transfer confirmed',
  draw_asset: 'Released',
  transfer_fee: 'Request fee',
  sign_fee: 'Fees paid',
  draw_fee: 'Completed',
  cancel: 'Canceled',
  cancel_paid: 'Request cancellation',
  cancel_escrow: 'Releaseing',
  not_received: 'Funds not received',
  unlock: 'Transfer canceled',
  refund_fee: 'Reimbursement fee',
  auto_cancel: 'Automatically Canceled',
};

export const notice = {
  title: 'Smart trading',
  fiatCurrency: 'Fiat currency',
  minPercentage: 'Price minimum',
  maxPercentage: 'Price maximum',
  above: 'Above',
  below: 'Below',
  frequency: 'Notification frequency',
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  smartTradingEdit: 'Smart trading edit',
  type: 'Order type',
  crypto: 'Cryptocurrency',
  alertCount: 'Notifications',
  alertGap: 'Notification interval',
  sace: 'Save',
  buy: 'I want to Buy',
  sell: 'I want to Sell',
  default: 'Please',
  setPriceAlert: 'Please choose A Crypto and A Fiat Currency Firstly.',
  times: 'times',
  saveSuccess: 'Save Successfully',
  createSuccess: 'Create Successfully',
  removeSuccess: 'Remove Successfully',
  changeSuccess: 'Change Successfully',
  tips: 'Changes will only be effective for newly released ads',
  notZero: 'Hello, dynamic price percentage is not allowed to set to 0',
  priceError: 'The minimum price cannot be greater than the maximum price',
  smartTrade:
    'Smart trading means that if another user posts an ad that meets your needs, a notification will be sent to you via the TIGA bot and a one-click direct transaction will be available.',
  postKyc:
    'Sorry, KYC are required to post ads, please complete KYC first.',
};

export const customerManagement = {
  title: 'Customer Management',
  whitelist: 'Whitelist',
  blacklist: 'Blacklist',
  inputPlaceholder: "Please input user's mixin ID",
  addToList: 'Add user via mixin ID',
  add: 'Add',
  remove: 'Remove',
  addSuccessfully: 'Add Customer Successfully',
  removeSuccessfully: 'Remove Successfully',
};

export const communityHelper = {
  name: 'Community Helper',
};

export const messageHelper = {
  name: 'Message Helper',
  warnInfo: 'Reminder: If you use the Xinsheng APP but cannot use the chat function, you can temporarily use this page to forward messages. It is recommended to download Mixin Messenger to use TIGA smoothly.',
  downloadMessenger: 'Download Messenger',
  groupInfo: 'Current Group Chat',
  textInfo: 'Forward Text',
  textInfoPlaceHolder: 'Please enter the text content to be forwarded (can be empty)',
  photosInfo: 'Forward Photos',
  uploadTips: 'Reminder: This is only a temporary forwarding of information to the group, TIGA does not make any guarantees for the content forwarded.',
};

export const rebate = {
  name: 'Referral',
  groupRatio: 'Group rebate',
  inviteRatio: 'You receive',
  friendsRatio: 'Friends receive',
  inviteNow: 'Invite',
  total: 'Dashboard',
  recommend: 'Referral',
  inviteList: 'Friends',
  rebateList: 'Commission',

  time: ['All', 'Today', 'Yesterday', 'This week', 'This month'],
  estimated: 'You earned',
  orderNum: 'Orders',
  customers: 'Users',
  ranking: 'Ranks:',
  viewRank: 'Ranking list',

  inviterRatio: 'You receive',
  inviteeRatio: 'Friends receive',
  inviteCode: 'Referral ID',
  inviteLink: 'Referral link',
  inviteNum: 'Friends',
  edit: 'Edit',
  invite: 'Invite',

  nickname: 'Nickname',
  traded: 'Traded',
  yes: 'Yes',
  no: 'No',
  inviteDate: 'Invite time',

  orderInfo: 'Order ID/Type',
  income: 'Commission earned',
  orderDate: 'Earned Time',

  inviteTitle: 'Invite your friends and make money together',

  rank: 'Rank',
  rankList: 'Ranking List',
  rankBrief:
    'The list shows the last 24 hours of ranking data, and only the top 20 are shown',
  revenue: 'Total Revenue',
  noRecords: 'No Record!',
  rebateType: [
    'Group rebate',
    'Public rebate',
    'Invite rebate',
    'Invite rebate',
  ],
};

export const statistics = {
  name: 'Statistics',
  total: 'Total',
  buyTotal: 'Buy',
  sellTotal: 'Sell',
  buy: 'Buy',
  sell: 'Sell',
  volume: 'Volume',
  price: 'Price',
  setTime: 'Set Time',
  startAt: 'Start Time',
  endAt: 'End Time',
  pickStartTime: 'Pick Start Time',
  pickEndTime: 'Pick End Time',
  onlyMaker: 'Only the data as Ad publisher',
};

export const invite = {
  name: 'Referral ID',
  placeholder: 'Input Referral ID',
  brief: 'After binding successfully, no modification is supported',
  bind: 'Bind',
  bindSuccess: 'Bind successfully',
  ruleTitle: 'Rules of returning Commission',
  rules: [
    {
      title:
        'Rebates are divided into <span class="strong">"Group Rebates"</span> and <span class="strong">"Invite Rebates"</span>',
      content:
        '"Group Rebates" & "Invite Rebates" is applicable to any users.',
    },
    {
      title:
        'The rules of <span class="strong">group rebates</span> are also very simple',
      content:
        'you only need to add the TIGA robot into the Mixin group, the group members will place orders through the TIGA robot of the group, and the group owner will receive the rebate.',
    },
    {
      title:
        ' <span class="strong">"Invitation Rebate"</span> requires the inviter and the invitee to be bound to an invitation relationship ',
      content:
        "before the inviter will receive commissions from the invitee's trade orders.",
    },
    {
      title:
        'The commission is <span class="strong">settled in real time</span>',
      content: 'and the crypto of settlement is the crypto of the order.',
    },
    {
      title: 'The initial commission rate is <span class="strong">10%</span>',
      content:
        'The KOL rebate program is now online, if you wish to apply, <a href="https://mixin.one/codes/255b9c54-b64e-4095-a789-b66506604461">you can click here.</a>',
    },
  ],
  refers: [
    'Refer here for the tutorial of <span class="strong">"Community Rebate"</span>',
    'Refer here for the tutorial of <span class="strong">"Open Rebate"</span>',
    'Refer here for the tutorial of <span class="strong">"Invite Rebates"</span>',
  ],
};

export const related = {
  name: 'His/Her Ads',
  empty: 'The related Ad is not found',
  view: 'View his/her Ads',
};
